export default "__VITE_ASSET__DZguY10X__"